import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Loading, PageHeader, Panel } from "../components/common";
import { Button } from "../components/ui/button";

const FIELDS = [["telefono", "Telefono"], ["email", "Email"], ["sito", "Sito web"], ["orari", "Orari"]];

function ShopEdit({ s, onSaved }) {
  const [f, setF] = useState(s);
  const [busy, setBusy] = useState(false);
  const inp = "mt-1 w-full rounded-lg border border-slate-200 px-2 text-sm";
  const save = async () => {
    setBusy(true);
    try { const body = Object.fromEntries(["telefono", "email", "sito", "orari", "descrizione", "descrizione_en"].map((k) => [k, f[k] || ""])); onSaved(await api(`/local/my-shops/${s.id}`, { method: "PUT", body })); toast.success("Dati aggiornati sul sito pubblico"); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Panel className="space-y-3" data-testid={`my-shop-${s.id}`}>
      <div className="flex items-center gap-3">{s.logo && <img src={s.logo} alt={`Logo ${s.nome}`} className="w-14 h-14 object-contain rounded ring-1 ring-slate-200" />}<div><h3 className="font-semibold text-[var(--navy)] text-lg">{s.nome}</h3><p className="text-xs text-slate-500">{s.tipo}{s.locale && ` \u00b7 locale ${s.locale}`}</p></div></div>
      <div className="grid sm:grid-cols-2 gap-3">{FIELDS.map(([k, l]) => <label key={k} className="block text-sm"><span className="text-xs text-slate-500">{l}</span><input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${inp} h-9`} data-testid={`my-shop-${k}`} /></label>)}</div>
      {[["descrizione", "Descrizione (italiano)"], ["descrizione_en", "Description (English)"]].map(([k, l]) => <label key={k} className="block text-sm"><span className="text-xs text-slate-500">{l}</span><textarea value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} rows={4} className={`${inp} py-2`} data-testid={`my-shop-${k}`} /></label>)}
      <Button className="rounded-full bg-[var(--teal)]" disabled={busy} onClick={save} data-testid="my-shop-save">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Save className="w-4 h-4 mr-1" />}Salva e pubblica</Button>
    </Panel>
  );
}

export default function MioLocale() {
  const [l, setL] = useState(null);
  useEffect(() => { api("/local/my-shops").then((d) => setL(d.shops)).catch(() => setL([])); }, []);
  if (!l) return <Loading />;
  return (
    <div className="space-y-5" data-testid="my-shop-page">
      <PageHeader title="Gestisci attività" subtitle="Aggiorna la scheda della tua attività sulla mappa del sito pubblico: le modifiche compaiono subito." />
      {!l.length ? <Panel><p className="text-sm text-slate-500">Nessun locale associato al tuo account. Chiedi al Direttore di associarti.</p></Panel>
        : l.map((s) => <ShopEdit key={s.id} s={s} onSaved={(n) => setL((x) => x.map((y) => (y.id === n.id ? n : y)))} />)}
    </div>
  );
}
